import { getColorStyle, TrilogyColor } from "./Color";
/**
 * Variant State
 */
export var VariantState;
(function (VariantState) {
    VariantState["MAIN"] = "MAIN";
    VariantState["ACCENT"] = "ACCENT";
    VariantState["INFO"] = "INFO";
})(VariantState || (VariantState = {}));
/**
 * Returns variant's classname depending on variant type
 * @param variantType {string} - VariantType
 * @returns {string} - Variant value
 */
export var getVariantClassName = function (variantType) {
    if (!variantType)
        return "";
    switch (variantType) {
        case "MAIN":
            return "main";
        case "ACCENT":
            return "accent";
        case "PRIMARY":
            return "primary";
        case "SECONDARY":
            return "secondary";
        case "GHOST":
            return "ghost";
        case "INFO":
            return "info";
        default:
            return "";
    }
};
/**
 * Returns variant's style depending on variant type
 * @param variantType {string} - VariantType
 * @returns {string} - Variant value
 */
export var getVariantStyle = function (variantType) {
    switch (variantType) {
        case "PRIMARY":
            return getColorStyle(TrilogyColor.MAIN);
        case "ACCENT":
            return getColorStyle(TrilogyColor.ACCENT);
        case "MAIN":
            return getColorStyle(TrilogyColor.MAIN);
        case "SECONDARY":
            return getColorStyle(TrilogyColor.MAIN_FADE);
        case "INFO":
            return getColorStyle(TrilogyColor.INFO);
        default:
            return "";
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmFyaWFudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL29iamVjdHMvZmFjZXRzL1ZhcmlhbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxZQUFZLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFFckQ7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxZQUlYO0FBSkQsV0FBWSxZQUFZO0lBQ3RCLDZCQUFhLENBQUE7SUFDYixpQ0FBaUIsQ0FBQTtJQUNqQiw2QkFBYSxDQUFBO0FBQ2YsQ0FBQyxFQUpXLFlBQVksS0FBWixZQUFZLFFBSXZCO0FBV0Q7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxJQUFNLG1CQUFtQixHQUFHLFVBQUMsV0FBb0I7SUFDdEQsSUFBSSxDQUFDLFdBQVc7UUFBRSxPQUFPLEVBQUUsQ0FBQTtJQUMzQixRQUFRLFdBQVcsRUFBRTtRQUNuQixLQUFLLE1BQU07WUFDVCxPQUFPLE1BQU0sQ0FBQTtRQUNmLEtBQUssUUFBUTtZQUNYLE9BQU8sUUFBUSxDQUFBO1FBQ2pCLEtBQUssU0FBUztZQUNaLE9BQU8sU0FBUyxDQUFBO1FBQ2xCLEtBQUssV0FBVztZQUNkLE9BQU8sV0FBVyxDQUFBO1FBQ3BCLEtBQUssT0FBTztZQUNWLE9BQU8sT0FBTyxDQUFBO1FBQ2hCLEtBQUssTUFBTTtZQUNULE9BQU8sTUFBTSxDQUFBO1FBQ2Y7WUFDRSxPQUFPLEVBQUUsQ0FBQTtLQUNaO0FBQ0gsQ0FBQyxDQUFBO0FBRUQ7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxJQUFNLGVBQWUsR0FBRyxVQUFDLFdBQW9CO0lBQ2xELFFBQVEsV0FBVyxFQUFFO1FBQ25CLEtBQUssU0FBUztZQUNaLE9BQU8sYUFBYSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQTtRQUN6QyxLQUFLLFFBQVE7WUFDWCxPQUFPLGFBQWEsQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLENBQUE7UUFDM0MsS0FBSyxNQUFNO1lBQ1QsT0FBTyxhQUFhLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQ3pDLEtBQUssV0FBVztZQUNkLE9BQU8sYUFBYSxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsQ0FBQTtRQUM5QyxLQUFLLE1BQU07WUFDVCxPQUFPLGFBQWEsQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLENBQUE7UUFDekM7WUFDRSxPQUFPLEVBQUUsQ0FBQTtLQUNaO0FBQ0gsQ0FBQyxDQUFBIn0=